import { useCallback, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../Redux/Hooks";
import {
  getWalletBalance,
  getWalletTransactions,
  getRechargeOrders,
} from "../Redux/ApiCalls/Dashboard/WhatsAppAPI";

/**
 * Hook for WhatsApp billing & usage: wallet balance, transactions, and recharge order history.
 */
export function useUsage() {
  const dispatch = useAppDispatch();
  const {
    whatsAppAccount,
    walletBalance,
    walletLoading,
    walletTransactions,
    walletTransactionsPage,
    walletTransactionsTotalPages,
    loading,
    error,
    isError,
    rechargeOrders,
    rechargeOrdersPage,
    rechargeOrdersTotalPages,
    rechargeOrdersLoading,
  } = useAppSelector((state) => state.whatsapp);

  const refresh = useCallback(() => {
    dispatch(getWalletBalance());
    dispatch(getWalletTransactions({ page: 1, page_size: 20, type: "credit", category: "recharge" }));
    dispatch(getRechargeOrders({ page: 1, page_size: 20 }));
  }, [dispatch]);

  const loadMoreTransactions = useCallback(() => {
    if (loading || walletTransactionsPage >= walletTransactionsTotalPages) return;
    dispatch(
      getWalletTransactions({
        page: walletTransactionsPage + 1,
        page_size: 20,
        type: "credit",
        category: "recharge",
      })
    );
  }, [dispatch, loading, walletTransactionsPage, walletTransactionsTotalPages]);

  const loadMoreRechargeOrders = useCallback(() => {
    if (rechargeOrdersLoading || rechargeOrdersPage >= rechargeOrdersTotalPages) return;
    dispatch(
      getRechargeOrders({
        page: rechargeOrdersPage + 1,
        page_size: 20,
      })
    );
  }, [dispatch, rechargeOrdersLoading, rechargeOrdersPage, rechargeOrdersTotalPages]);

  useEffect(() => {
    dispatch(getWalletBalance());
    dispatch(getWalletTransactions({ page: 1, page_size: 20, type: "credit", category: "recharge" }));
    dispatch(getRechargeOrders({ page: 1, page_size: 20 }));
  }, [dispatch]);

  return {
    whatsAppAccount,
    walletBalance,
    walletLoading,
    walletTransactions,
    walletTransactionsPage,
    walletTransactionsTotalPages,
    loading,
    error,
    isError,
    rechargeOrders,
    rechargeOrdersPage,
    rechargeOrdersTotalPages,
    rechargeOrdersLoading,
    refresh,
    loadMoreTransactions,
    loadMoreRechargeOrders,
  };
}
